import { useContext } from 'react';
import { ProjectsContext } from '../context/projectsContext';

export const useProjects = () => {
  const context = useContext(ProjectsContext);

  if (!context) {
    throw new Error('useProjects must be used within ProjectsProvider');
  }

  return context;
};
